// Copyright 2017 Rigo Investment Sagl.
// This file is part of RigoBlock.

import drago from './v2/drago-v2.json'
import dragoeventful from './v2/dragoEventful-v2.json'
import dragofactory from './v2/dragoFactory-v2.json'
import dragoregistry from './v2/dragoRegistry-v2.json'
import erc20 from './v2/erc20.json'
import ethusd from './v2/ethusd.json'
import exchange from './v2/exchange.json'
import fundproxy from './v2/fundProxy.json'
import getMultiPoolsData from './v2/getMultiPoolsData.json'
import getMultipleBalances from './v2/getMultipleBalances.json'
import parityregister from './v2/parityRegister.json'
import rigotoken from './v2/rigoToken-v2.json'
import rigotokenfaucet from './v2/rigoTokenFaucet-v2.json'
import tokenWrapper from './v2/tokenWrapper-v2.json'
import vault from './v2/vault-v2.json'
import vaulteventful from './v2/vaultEventful-v2.json'
import vaultfactory from './v2/vaultFactory-v2.json'
import weth from './v2/weth.json'
import zeroExExchange from './v2/zeroExExchange.json'

// Legacy v1 contracts
// import vault from './v1/vault.json';
// import vaultfactory from './v1/vaultFactory.json';
// import registry from './v1/registry.json';
// import tokenreg from './v1/tokenreg.json';
// import exchange from './v1/exchange.json';
// import oracle from './v1/oracle.json';
// import dragofactory from './v1/dragofactory.json';
// import drago from './v1/drago.json';
// import eventful from './v1/eventful.json';
// import ethusd from './v1/ethusd.json';
// import dragoregistry from './v1/dragoregistry.json';
// import exchangeeventful from './v1/exchangeeventful.json';
// import vaulteventful from './v1/vaultEventful.json';
// import nav from './v1/nav.json';
// import parityregister from './v1/parityregister.json';
// import rigotoken from './v1/rigoToken.json';

export {
  vault,
  vaultfactory,
  dragoregistry,
  exchange,
  erc20,
  dragofactory,
  drago,
  dragoeventful,
  ethusd,
  fundproxy,
  tokenWrapper,
  vaulteventful,
  parityregister,
  rigotoken,
  rigotokenfaucet,
  weth,
  zeroExExchange,
  getMultipleBalances,
  getMultiPoolsData
}
